import React from 'react';
import './index.scss';

const Footer = () => {
  const urlParams = new URL(window.location.href);
  let aboutClass = "";
  if (urlParams && urlParams.pathname === '/about') {
    aboutClass = 'about'
  }
  return (
    <div className={`footer clearfix ${aboutClass}`}>
      <div className="company-info">花生未来（广州）科技有限公司
      {/* <a href="https://www.shiguangxu.com" target="_blank" rel="noopener noreferrer"> www.shiguangxu.com </a> */}
        &nbsp;2022 &copy; All Rights Reserved</div>
      <div className="goverment-records">
        <span className="police"></span>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602007601" target="_blank" rel="noopener noreferrer">粤公网安备 44010602007601号</a>
        <span className="line"></span>
        <a className="space" href="http://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">粤ICP备 20003028号</a>
      </div>
    </div>
  );
}

export default Footer;